import React, { Component } from 'react';
import '../../App.css';
import '../../styles/app-demo.css';
import atmLocatorImage from '../../assets/mobile-app/atm-locator-x.png';

class AtmLocator extends Component {

  render() {

    return (
      <section>
        <div className="fintwist-interactive-mobile">
          <section className="mobile-app-wrapper">
            <div className="orange-header">
              {this.props.routedFrom === 'menu' ?
              <i onClick={() => this.props.toggleNewRoute('dashboard')} className="fa fa-angle-left"></i>
              :
              <i onClick={() => this.props.toggleNewRoute('login')} className="fa fa-angle-left"></i>
              }
              <h2>ATM Locator</h2>
            </div>
            <img id="atm-image" src={atmLocatorImage} alt={''} />
          </section>
        </div>
      </section>
    );
  }
}

export default AtmLocator;
